import { InventoryTypes } from "@/common/enums";

export default class ScreenLayoutModel {
    globalId: string = '';
    inventoryType: InventoryTypes = InventoryTypes.Inventory;
    screenSection: number = 1;
    displayOrder: number = 0;
    menuGroupId: string = '';
}